module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/$.library.js
// module id = w5lU
// module chunks = 0